<template>
    <div>
        <b-container fluid>
            <b-row>
                <b-col cols="12">
                    <app-sub-title text="Servicios de escolta prestados" />
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12">
                    <app-bodyguard-services-filters
                        @filter="onFilter"
                        :show-client="false"
                    />
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12">
                    <app-bodyguard-services-list
                        :data="services"
                        @see-card-service="showServiceDetail"
                        @change-page="onChangePage"
                        @sort="onSort"
                    />
                </b-col>
            </b-row>
        </b-container>
        <app-pop-up id="bodyguard-service-detail-dialog" size="large" title="Información del servicio prestado">
            <template slot="body">
                <app-bodyguard-service-card
                    v-if="!!selectedService"
                    :bodyguard-service="selectedService"
                />
            </template>
        </app-pop-up>
    </div>
</template>
<script>
import BodyguardServicesList from '@components/Vigilance/Bodyguard/BodyguardServices/BodyguardServicesList/BodyguardServicesList';
import BodyguardServicesFilters from '@components/Vigilance/Bodyguard/BodyguardServices/BodyguardServicesFilters/BodyguardServicesFilters';
import bodyguardRepository from '@repositories/bodyguard.repository.js';
import BodyguardServiceCard from '@components/Vigilance/Bodyguard/BodyguardServices/BodyguardServiceCard/BodyguardServiceCard';
export default {
    name: 'bodyguard_service_admin_clients',
    components: {
        appBodyguardServicesList: BodyguardServicesList,
        appBodyguardServicesFilters: BodyguardServicesFilters,
        appBodyguardServiceCard: BodyguardServiceCard
    },
    data: () => ({
        services: {},
        filters: null,
        page: 1,
        sortBy: 'body_guard_services.start_date',
        sortDir: 'desc',
        selectedService: ''
    }),
    methods: {
        onFilter(filters) {
            this.filters = filters;
            this.page = 1;
            this.loadServices();
        },
        async loadServices() {
            const payload = {...this.filters, sortBy: this.sortBy, sortDir: this.sortDir, client: this.client.id};
            const br = {...bodyguardRepository};

            try {
                const { data } = await br.loadBodyguardServices(payload, this.page);
                this.services = data;
            } catch (err) {
                toastr.error(`Ocurrió un error al cargar los servicios [${err.message}]`);
            }
        },
        initialize() {
            this.loadServices();
        },
        showServiceDetail(service) {
            this.selectedService = service;
            this.$bus.$emit('bodyguard-service-detail-dialog.open');
        },
        onChangePage(page) {
            this.page = page;
            this.loadServices();
        },
        onSort(ctx) {
            this.sortBy = ctx.sortBy;
            this.sortDir = ctx.sortDir;
            this.loadServices();
        }
    },
    created() {
        this.initialize();
    }
}
</script>
